__turbopack_context__.v({
  "bottomSheet": "ProductCardColorAccessory-module__Ho022q__bottomSheet",
  "media": "ProductCardColorAccessory-module__Ho022q__media",
  "pricingInfo": "ProductCardColorAccessory-module__Ho022q__pricingInfo",
  "ringSpec": "ProductCardColorAccessory-module__Ho022q__ringSpec",
  "root": "ProductCardColorAccessory-module__Ho022q__root",
  "stepFadeIn": "ProductCardColorAccessory-module__Ho022q__stepFadeIn",
});
